import { writable } from 'svelte/store';

let siteText = 'ControLar Gestão Imobiliária';

export const alt                = writable(" | " + siteText);
export const headerTitle        = writable(" | " + siteText);
export const headerTitleHome    = writable(siteText);
export const textSite           = writable(siteText);

export const mailAtendimento    = writable("siteatendimento@controlarimoveis.com.br");
export const mailLocacao        = writable("siteatendimento@controlarimoveis.com.br");
export const mailVendas         = writable("siteatendimento@controlarimoveis.com.br");
export const mailCondominios    = writable("siteatendimento@controlarimoveis.com.br");
export const mailRH             = writable("siteatendimento@controlarimoveis.com.br");

export const textTelefone       = writable("(51) 3337-1000");
export const linkTelefone       = writable("tel://5133371000");

export const textWhatsapp       = writable("(51) 99879-4683");
export const linkWhatsapp       = writable("https://wa.me/5551998794683");

export const linkFacebook       = writable("https://www.facebook.com/controlargestaoimobiliaria");
export const linkInstagram      = writable("https://www.instagram.com/controlargestaoimobiliaria/");
export const linkYoutube        = writable("");

export const linkMapa           = writable("https://goo.gl/maps/VJWQFuCwmzkhHsbs8");
export const linkWaze           = writable("https://www.waze.com/ul?place=ChIJlSPvacJ5GZURfadEu7o7S4o&ll=-30.01768840%2C-51.18830860&navigate=yes");
export const linkUber           = writable("https://m.uber.com/ul/?action=setPickup&client_id=9zzPwceWa0hEu1fLOgKkUoEp0EmIVgjH&pickup=my_location&dropoff[formatted_address]=ControLar%20Gest%C3%A3o%20Imobili%C3%A1ria%20-%20Avenida%20Crist%C3%B3v%C3%A3o%20Colombo%20-%20Floresta%2C%20Porto%20Alegre%20-%20RS%2C%20Brasil&dropoff[latitude]=-30.017688&dropoff[longitude]=-51.188309");

export const linkAPI            = writable("http://www.mapit.com.br/");
export const linkAV             = writable("https://appcontrolarimoveis.com.br/controlar");
export const linkConheca        = writable("/conheca");

export const textAtendimento    = writable("Segunda à Sexta-Feira, 09:00 às 11:45, 13:30 às 16:30");
export const textEndereco       = writable("Av. Cristóvão Colombo, 3187/605, Porto Alegre - RS");
export const textCNPJ           = writable("11937393000180");
export const textCreci          = writable("14278");